import { message } from 'components';
import { aiAgentCenterMessages } from 'messages';
import { useUpdateCallSessionMutation } from 'services';
import { CallSessionDto, UpdateCallSessionDto } from 'types';

export const useUpdateCallSession = () => {
  const [handleIntercept, { isLoading }] = useUpdateCallSessionMutation();

  const updateCallSession = (data: UpdateCallSessionDto, callBack: (data: CallSessionDto) => void) => {
    return handleIntercept(data)
      .unwrap()
      .then((res) => {
        callBack(res.data);
      });
  };

  return {
    updateCallSession,
    isLoading
  };
};
